import { FC } from 'react'

import { IconButton } from '@/compositions/@buttons/IconButton/IconButton'
import { trans } from '@/helpers/trans'

import './LogOutButton.scss'

interface LogOutButtonProps {
    onClick: () => void
    className?: string
}

export const LogOutButton: FC<LogOutButtonProps> = ({ onClick, className = '' }) => (
    <IconButton
        icon="log-out"
        iconPos="right"
        text={trans('common.logout')}
        onClick={onClick}
        className={`log-out-button ${className}`}
        iconClassName="log-out-button__icon"
    />
)
